import {axiosBffFetch, FetcherOptions} from '../../axios/axiosBffFetch';
import type {TicketSalesResultVo} from '../../common/shared/api/nicolas/vo/TicketSalesVo.interface';
import type {UseTicketHistoryQueryVariables} from '../../graphql/generated/types';

/**
 * 이용권 사용 내역 조회
 *
 * Origin: pageNicolasApi.getCouponUsageHistory
 * API: POST /gateway/api/v1/store/coupon_history/use
 */
export async function postStoreCouponHistoryUse(
  params?: UseTicketHistoryQueryVariables,
  options?: FetcherOptions
): Promise<TicketSalesResultVo> {
  const response = await axiosBffFetch(
    '/api/gateway/api/v1/store/coupon_history/use',
    {
      method: 'POST',
      data: {
        page: params?.page,
        free_only: params?.freeOnly,
      },
    },
    options
  );
  return response.data;
}
